import { ApiClientBase } from "api/ApiClientBase";
import qs from "qs";
import { v4 as uuidv4 } from "uuid";

class AuthApiClient extends ApiClientBase {
    oidcLogout() {
        return this.get(`/api/v1/auth/oidc-logout`).then((r) => r.data);
    }

    refresh() {
        return this.post(`/api/v1/auth/refresh`).then((r) => r.data);
    }

    buildChallengeUrl(returnUrl) {
        const deviceId = this.getDeviceId();
        return "/api/v1/auth/challenge?" + qs.stringify({ returnUrl, deviceId });
    }

    getDeviceId() {
        const DEVICE_ID_KEY = "deviceId";
        let deviceId = localStorage.getItem(DEVICE_ID_KEY);
        if (!deviceId) {
            deviceId = uuidv4();
            localStorage.setItem(DEVICE_ID_KEY, deviceId);
        }
        return deviceId;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthApiClient();
